import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      d: "M5 7.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6m-5 6a5 5 0 0 1 10 0 .5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5"
    }, null, -1),
    createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M11.178 14H13.5a.5.5 0 0 0 .5-.5 5 5 0 0 0-5.242-4.994A6.24 6.24 0 0 1 11.25 13.5q0 .262-.072.5M8.132 7.373a3 3 0 1 0 0-5.745A4.24 4.24 0 0 1 9.25 4.5a4.24 4.24 0 0 1-1.118 2.873",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const interfaceUsersMultiple = { render };
export {
  interfaceUsersMultiple as default,
  render
};
//# sourceMappingURL=interface-users-multiple.svg.js.map
